Alpine.data('alpine_floating_label', () => ({
  hasValue: false,

  setValue(value) {
    this.hasValue = !!value;
  },
}));
